import React from 'react';

const RecurringCustomers = ({ data }) => {
    if (!data) return null;

    return (
        <div className="card shadow-sm h-100">
            <div className="card-body">
                <h6 className="card-title mb-3">Recurring Customers</h6>
                <div className="row text-center g-2 mb-3">
                    <div className="col-3">
                        <div className="p-2 bg-light rounded">
                            <small className="text-muted d-block">Total</small>
                            <strong>{data.total_customers}</strong>
                        </div>
                    </div>
                    <div className="col-3">
                        <div className="p-2 bg-light rounded">
                            <small className="text-muted d-block">New (1 order)</small>
                            <strong>{data.new_count}</strong>
                        </div>
                    </div>
                    <div className="col-3">
                        <div className="p-2 bg-light rounded">
                            <small className="text-muted d-block">Returning (2-3)</small>
                            <strong>{data.returning_count}</strong>
                        </div>
                    </div>
                    <div className="col-3">
                        <div className="p-2 bg-light rounded">
                            <small className="text-muted d-block">Loyal (4+)</small>
                            <strong>{data.loyal_count}</strong>
                        </div>
                    </div>
                </div>
                {data.frequency_bands && data.frequency_bands.length > 0 && (
                    <div className="mb-3">
                        <h6 className="mb-2" style={{ fontSize: '0.85rem' }}>Order Frequency Distribution</h6>
                        <div className="table-responsive">
                            <table className="table table-sm table-bordered mb-0">
                                <thead className="table-light">
                                    <tr>
                                        <th>Segment</th>
                                        <th className="text-end">Customers</th>
                                        <th className="text-end">%</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {data.frequency_bands.map((seg, i) => (
                                        <tr key={i}>
                                            <td>{seg.segment}</td>
                                            <td className="text-end">{seg.count}</td>
                                            <td className="text-end">{seg.percentage}%</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                )}
                {data.top_returning && data.top_returning.length > 0 && (
                    <div>
                        <h6 className="mb-2" style={{ fontSize: '0.85rem' }}>Top Returning Customers</h6>
                        <div className="table-responsive">
                            <table className="table table-sm table-bordered mb-0">
                                <thead className="table-light">
                                    <tr>
                                        <th>Customer</th>
                                        <th className="text-end">Orders</th>
                                        <th className="text-end">Total Spent</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {data.top_returning.map((c, i) => (
                                        <tr key={i}>
                                            <td>{c.customer_name}</td>
                                            <td className="text-end">{c.order_count}</td>
                                            <td className="text-end">{c.total_spent?.toLocaleString(undefined, { minimumFractionDigits: 3 })}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default RecurringCustomers;
